import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { formatDateTime } from '@/helpers/date-helper';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { useI18n } from '@/helpers/composables/useI18n';
import { storeToRefs } from 'pinia';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { useMounted } from '@vueuse/core';
import { useExperiment } from '@/libraries/experiment';
import LinearOfferCTA from '@/components/experiments/LinearTVExp/LinearOfferCTA.vue';
import ListOfferPresentation from '@/features/buybox/components/list/ListOfferPresentation.vue';
import { LinearOfferEpisode } from '@/interfaces/buybox';
import { BuyboxRegularOffer } from '@/features/buybox/types/types';
import { TitleDetail } from '@/interfaces/title-details-graphql';


export default /*#__PURE__*/_defineComponent({
  __name: 'LinearExtraShowings',
  props: {
    linearAdditionalEpisodes: null,
    buyboxOffer: null,
    title: null,
    seasonNumber: null,
    variant: null
  },
  emits: ["openBuyBoxInfoModal"],
  setup(__props: any) {

const { tc } = useI18n();
const { country, language } = storeToRefs(useLanguageStore());





const isMounted = useMounted();

const showLinearEpisodes = ref(false);

function v2Date(availableFromTime: string | null | undefined) {
	if (!availableFromTime) {
		return null;
	}

	return formatDateTime(new Date(availableFromTime), language.value, country.value, {
		weekday: 'short',
		day: '2-digit',
		month: '2-digit',
	});
}

const ESTTimeZone = 'America/New_York';
const DETimeZone = 'Europe/Berlin';

function v2Time(availableFromTime: string | null | undefined, availableToTime: string | null | undefined) {
	if (!availableFromTime) {
		return null;
	}

	const rawDateStart = new Date(availableFromTime as unknown as Date);
	const rawDateEnd = new Date(availableToTime as unknown as Date);

	const start = formatDateTime(rawDateStart, language.value, country.value, {
		hour: '2-digit',
		minute: '2-digit',
	});

	const end = formatDateTime(rawDateEnd, language.value, country.value, {
		hour: '2-digit',
		minute: '2-digit',
		timeZone:
			country.value === 'US'
				? ESTTimeZone
				: country.value === 'DE'
				? DETimeZone
				: isMounted.value
				? Intl.DateTimeFormat().resolvedOptions().timeZone
				: 'UTC',
		timeZoneName: 'short',
	});

	return `${start} - ${end}`;
}

const { trackEvent } = useExperiment('EXP_LINEAR_TV');

function handleShowEpisodes() {
	showLinearEpisodes.value = !showLinearEpisodes.value;

	trackEvent({
		action: 'click',
		label: showLinearEpisodes.value ? 'see_more_expand' : 'see_more_collapse',
	});
}

return { __sfc: true,tc, country, language, isMounted, showLinearEpisodes, v2Date, ESTTimeZone, DETimeZone, v2Time, trackEvent, handleShowEpisodes, faChevronDown, faChevronUp, LinearOfferCTA, ListOfferPresentation }
}

})